<template>
  <div class="cmp-distribution-shops-shop_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="search">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth:'200px',
            minWidth:'200px',
            width:'200px'
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>

        <Dropdown
          :options="channelsTV"
          :selected="channelsTV.find(e => e.value == basicFilter.channel)"
          :placeholder="'Select Channel'"
          deselect
          borderbottom
          @selectedChange="e => onDropdownChange('channel', e)"
        ></Dropdown>
      </div>
      <div class="right-container ut-colcen">
        <div class="ut-flex">
          <button class="dt-button v5 s8" @click="onShopManagementClicked">
            {{ $t("shop_management") }}
          </button>
          <button class="dt-button v5 s8" @click.stop="onUpdateShopsClicked">
            {{ $t("shops_update") }}
          </button>
        </div>
      </div>
    </div>

    <div class="dt-page--body">
      <NTable
        :id="'distribution-shops-shop_list'"
        class="h1"
        :config="tableConfig"
        :headers="headers"
        :items="list"
        @scrollnext="onListScroll"
        :loadingFlag="loadingFlag"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item)
            }"
            @click="onRowClicked(item)"
            :title="'Click to see Shops List'"
          >
            <td v-bind="tdcon('shop')">
              <span class="txtov" :title="item['shop']">{{
                item["shop"]
              }}</span>
            </td>
            <td v-bind="tdcon('channel')">
              <span class="txtov" :title="item['channel']">{{
                item["channel"]
              }}</span>
            </td>
            <td v-bind="tdcon('shop_general_groups')">
              <span class="txtov" :title="item['general_groups']">{{
                item["general_groups"]
              }}</span>
            </td>
            <td v-bind="tdcon('shop_other_groups')">
              <span class="txtov" :title="item['other_groups']">{{
                item["other_groups"]
              }}</span>
            </td>
            <td v-bind="tdcon('status')">
              <span class="txtov" :title="item['status']">{{
                $dft.capSnake($t(item["status"]))
              }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                v-if="item['status']=='not_active'"
                src="static/icons/delete.svg"
                @click.stop="(e) => onDeleteShop(item)"
                class="dt-icon v5 s2 ut-center"
                alt
                title="Delete Shop"
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <Sidewindow
      :navConfig="defaultConfig"
      :value="shopsDetailsFlag"
      @closed="onCloseShopsDetails"
    >
      <ShopsSidewindow />
    </Sidewindow>

    <ModalContainer :modalKey="'shopManagement'" :width="'1000'">
      <ShopManagement @cancelled="onDialogCancelled" @added="onShopAdded" />
      <!-- :advancedSearchData="advancedSearchData"
        @export="onAdvancedSearchExport" -->
    </ModalContainer>
  </div>
</template>

<script>
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";
import * as ActionTypes from "../../store/types";

import { DistributionStoreNamespace as storeNS } from "../../store";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { shopsDistributionActions } from "../../store/shops/actions";
import { shopsDistributionGetters } from "../../store/shops/getters";

import {
  distributionShopListLDTRoutes,
  getDistributionShopDetailsSelectable
} from "../../router/routes";
import {
  childOfOrEqualDetails,
  handleFromRoute
} from "../../../../utility/route";

import ShopsSidewindow from "./shops-sidewindow";
import { async } from "rxjs/internal/scheduler/async";
import { forEach } from "ramda";
import { createTV } from "../../../../models/text-value.model";
import {
  closeModalRoute,
  createModalMixin,
  openModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import { ShopsService } from "../../services/shops.service";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import ShopManagement from "./shop-management";
import { ConfirmationService ,createConfirmResult } from '../../../../dt-plugins/confirmation/confirmation.service';
import { NotificationService } from "@dtplugins/notification/notification.service";
const LDTConfig = {
  entityName: "shop",
  ldtRoutes: distributionShopListLDTRoutes,
  detailsSelectableFunction: getDistributionShopDetailsSelectable,
  primaryKey: "shop_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.ShopDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.ShopDetails.FETCH.SINGLE
};

export default {
  components: {
    InputField,
    NTable,
    ModalContainer,

    ShopsSidewindow,
    ShopManagement
  },
  data: function() {
    return {
      start: 0,

      selectedClickedShop: null,
      defaultConfig: defaultConfig,
      getDistributionShopDetailsSelectable: getDistributionShopDetailsSelectable
    };
  },
  mixins: [
    createFetchListMixin(ActionTypes.ShopList.FETCH.ALL, 19, {
      advancedSearchable: false,
      searchable: true,
      scrollable: true
    }),
    createModalMixin("shopManagement"),
    createLDTHost(LDTConfig)
  ],
  computed: {
    ...mapGetterObject(storeNS, shopsDistributionGetters),

    tableConfig: function() {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40
      });
    },
    list: function() {
      console.log("Shop list ", this.shopList?.shops);
      return this.shopList?.shops || [];
    },
    headers: function() {
      return [
        createTableHeader("shop", { fw: 700 }),
        createTableHeader("channel", { f: 0.5 }),
        createTableHeader("shop_general_groups", { f: 0.5 }),
        createTableHeader("shop_other_groups", { f: 0.5 }),
        createTableHeader("status"),
        createTableHeader("options",{ text:false ,mw:40  })
      ];
    },
    filter: function() {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter
      };
    },

    channels: function() {
      console.log("Channels ", this.shopList?.channels);
      return this.shopList?.channels || [];
    },

    channelsTV: function() {
      // console.log("ChannelsTV ", createTV(this.channels, "channel", "channel"));
      return createTV(this.channels, "channel", "channel");
    },

    shopsDetailsFlag: function() {
      return childOfOrEqualDetails(distributionShopListLDTRoutes, this.$route);
    }
  },
  methods: {
    ...mapActionObject(storeNS, shopsDistributionActions),

    selectedRow: function(shop) {
      return (
        this.selectedClickedShop &&
        this.selectedClickedShop["shop_id"] === shop["shop_id"]
      );
    },

    defaultBasicFilter() {
      return {
        searchString: "",
        channel: ""
      };
    },

    onListScroll: function(value) {
      console.log("Shop Scroll");
      this.scrollSubject.next(value);
    },

    onDropdownChange(name, e) {
      this.basicFilter[name] = e.value;
      this.fetchListReset();
    },

    onShopManagementClicked: function() {
      openModalRoute(this, "shop_management");
    },

    onDialogCancelled: function() {
      // this.$router.push({
      //   ...this.$route,
      //   query: {
      //     modal: undefined
      //   }
      // });
      closeModalRoute(this);
    },

    onShopAdded: function(payload) {
      console.log("ok shop ", payload);
      this.onDialogCancelled();
      this.fetchListReset();
    },

    onUpdateShopsClicked: async function() {
      console.log("Update Shops Clicked ");
      await ShopsService.updateShops();
      setTimeout(() => {
          NotificationService.showNotification({
            text: "Updated shops are completed",
            timeout: 5000,
          });
      }, 10);
      this.fetchListReset();
      await ShopsService.getShopManagement();
    },

    // Start Sidewindow
    onRowClicked: function(shop) {
      console.log("shops sidewindow ", shop);
      if (this.loadingFlag) {
        return;
      }
      this.selectedClickedShop = shop;
      this.$router.push({
        name: distributionShopListLDTRoutes.names.tab,
        params: {
          shop_id: shop.shop_id,
          tab: "overview"
        }
      });
    },
    onCloseShopsDetails: function() {
      this.selectedClickedShop = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: distributionShopListLDTRoutes.names.list
        });
      });
    },
    onDeleteShop:async function(item){
      const confirmationResult = await confirmDelete(
        "Shop",
        item.shop
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.ShopList.DELETE.SINGLE](item);
      }
        // const confirmationResult = await ConfirmationService.createP({
        //   body: this.$t("delete_confirmation_msg_shop"),
        //   results: [
        //     createConfirmResult({
        //       value: "cancel",
        //       text: "Cancel",
        //       classes: ["s7"],
        //     }),
        //     createConfirmResult({
        //       value: "ok",
        //       text: "OK",
        //       classes: ["v1 s7"],
        //     }),

        //   ],
        // });
        // console.log(item)
        // if (confirmationResult === "ok") {
        //   this[ActionTypes.ShopList.DELETE.SINGLE](item);
        // }
    }
  }
};
</script>

<style lang="scss">
.cmp-distribution-shops-shop_list {
  .dt-page--body {
    --offset: 120px;
  }

  .dt-page--top-bar {
    .dropdown {
      width: 148px;
      margin-top: -1px;
      margin-right: 10px;
      margin-left: 20px;
    }
  }
}
</style>
